import RouteTemplate from "ember-route-template";
import ProxyviewsDirectoryBrowser from "../components/proxyviews-directory-browser";

export default RouteTemplate(
  <template>
    <section class="proxyviews-directory-page">
      <div class="pd-hero">
        <span class="pd-hero__eyebrow">ProxyViews Directory</span>
        <h1 class="pd-hero__title">Find your perfect <span class="pd-hero__dynamic-keyword">proxy provider</span></h1>
        <p class="pd-hero__subtitle">
          Compare verified proxy providers with real benchmarks, transparent
          pricing, and community reviews — all in one place.
        </p>

        <div class="pd-hero__actions">
          <a class="pd-hero__cta-primary" href="#provider-grid">Browse Providers ↓</a>
          <a class="pd-hero__cta-link" href="/providers/compare">⚖ Compare Side-by-Side</a>
        </div>

        <div class="pd-hero__stats">
          <div class="pd-hero__stat">
            <span class="pd-hero__stat-value">{{@model.meta.total_count}}</span>
            <span class="pd-hero__stat-label">Providers</span>
          </div>
          <div class="pd-hero__stat">
            <span class="pd-hero__stat-value">{{@model.meta.review_count_label}}</span>
            <span class="pd-hero__stat-label">Reviews</span>
          </div>
          <div class="pd-hero__stat">
            <span class="pd-hero__stat-value">{{@model.meta.avg_rating_label}}</span>
            <span class="pd-hero__stat-label">Avg Rating</span>
          </div>
          <div class="pd-hero__stat">
            <a href="/benchmarks" class="pd-hero__stat-link">
              <span class="pd-hero__stat-value">📊</span>
              <span class="pd-hero__stat-label">Live Benchmarks</span>
            </a>
          </div>
        </div>
      </div>

      <div class="pd-trust-strip">
        <div class="pd-trust-item">
          <span class="pd-trust-icon">🏆</span>
          <span class="pd-trust-text">Verified Benchmarks</span>
        </div>
        <div class="pd-trust-item">
          <span class="pd-trust-icon">💰</span>
          <span class="pd-trust-text">Transparent Pricing (per GB & IP)</span>
        </div>
        <div class="pd-trust-item">
          <span class="pd-trust-icon">🌍</span>
          <span class="pd-trust-text">Real Community Reviews</span>
        </div>
        <div class="pd-trust-item">
          <span class="pd-trust-icon">⚡</span>
          <span class="pd-trust-text">Live Speed Tests</span>
        </div>
      </div>

      <div id="provider-grid">
        <ProxyviewsDirectoryBrowser @providers={{@model.providers}} @meta={{@model.meta}} />
      </div>
    </section>
  </template>
);
